export const baseUrl = "https://argo-backend-api.herokuapp.com";

// export const baseUrl = "http://192.168.1.5:5001";

// export const baseUrl = "http://localhost:3001"

export const apiPath = baseUrl;
